import { Routes } from "@angular/router";
import { DeliveryOrdersComponent } from "../modules/orders/components/pages/delivery-orders/delivery-orders.component";
import { AuthGuardService } from "../modules/auth/services/auth-guard.service";
import { Permissions } from "../modules/auth/permissions/permissions";
import { DeliveryOrderDetailsComponent } from "../modules/orders/components/pages/delivery-order-details/delivery-order-details.component";
import { DeliveryDashboardComponent } from "../modules/dashboard/components/pages/delivery-dashboard/delivery-dashboard.component";
import { DriverManagementPageComponent } from "../modules/drivers-management/components/pages/driver-management-page/driver-management-page.component";
import { DriverFormPageComponent } from "../modules/drivers-management/components/pages/driver-form-page/driver-form-page.component";
import { DriverDetailsPageComponent } from "../modules/drivers-management/components/pages/driver-details-page/driver-details-page.component";
import { ZoneManagementPageComponent } from "../modules/delivery-zones-management/components/pages/zone-management-page/zone-management-page.component";
import { ZoneFormPageComponent } from "../modules/delivery-zones-management/components/pages/zone-form-page/zone-form-page.component";

export const deliveryAdminRoutes: Routes = [
  {
    path: '',
    component: DeliveryDashboardComponent, // will change this later to actual dashboard component
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'drivers',
    component: DriverManagementPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'drivers/new',
    component: DriverFormPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'drivers/:id',
    component: DriverDetailsPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'drivers/:id/edit',
    component: DriverFormPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'zones',
    component: ZoneManagementPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'zones/new',
    component: ZoneFormPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'zones/:id/edit',
    component: ZoneFormPageComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'orders',
    component: DeliveryOrdersComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
  {
    path: 'orders/:id',
    component: DeliveryOrderDetailsComponent,
    canActivate: [AuthGuardService],
    data: { permission: [Permissions.IS_DELIVERY_MANAGER] }
  },
]
